import axios from 'axios';
import authHeader from "@/service/auth-header";

class SimplyInvestingService {

    async resetPassword(id, data) {
        return await axios.put(`/api/simplyinvesting/client/reset/password/${id}`, data, {headers: authHeader()})
    }

}

export default new SimplyInvestingService();
